var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.optionProducts),function(optionProduct){return _c('photo-selection-group',{key:optionProduct.CatalogPackageOptionProductID,attrs:{"option-product":optionProduct}})}),_vm._v(" "),_c('photo-selection-form-inputs')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dc2bd9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/default/catalog-mix/components/PhotoSelection/PhotoSelection.vue
// module id = 1419
// module chunks = 2